import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {OnboardingDialogMrGreenBox} from "./onboarding-dialog.mrgreen.box";
import {OnboardingDialogDefaultBox} from "./onboarding-dialog.default.box";
import {OnboardingDialog888CasinoBox} from "./onboarding-dialog.888casino.box";

export const OnboardingDialogBox = styledByTheme(OnboardingDialogDefaultBox)
    .forMrGreen(OnboardingDialogMrGreenBox)
    .forCasino888(OnboardingDialog888CasinoBox)
    .apply();